// Extracted verbatim from pages/coach/Schedule.jsx (2026-06-08 P3 refactor).
import { useEffect, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import {
    DAY_LABELS, DAY_LABELS_LONG, HALF_HOUR_TIMES, formatTimeDisplay,
    isoDate, startOfWeekMon, addDays, weekRangeLabel, jsDayToMonIdx,
} from "@/lib/schedule";
import { CATEGORIES, CATEGORY_LABELS } from "@/lib/workoutTaxonomy";
import { ModalShell, Field, inputClass } from "./ModalShell";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function FloatingNowPill({ slot, onOpen }) {
    return (
        <button
            type="button"
            data-testid="floating-now-pill"
            onClick={onOpen}
            className="fixed bottom-6 right-6 z-40 inline-flex items-center gap-3 px-4 py-3 bg-brand-red text-white shadow-2xl border border-brand-red/40 rounded-full hover:bg-brand-red/90 transition-all animate-pulse"
        >
            <span className="text-[10px] font-bold tracking-[0.25em] uppercase opacity-80">● Now</span>
            <span className="font-bold">{formatTimeDisplay(slot.start_time)}</span>
            <span className="text-xs opacity-90">
                {slot.booking_count}/{slot.capacity} · tap to open
            </span>
        </button>
    );
}

